import { Link } from 'react-router-dom';
import { ArrowRight, Globe, Building2, Award, Users } from 'lucide-react';
import SEO from '../components/SEO';

// Client logos image containing all brand logos
const CLIENT_LOGOS_IMAGE = 'https://customer-assets.emergentagent.com/job_3a8e81e0-2de4-4c76-829e-02137c446df7/artifacts/4f3y1v78_clients-logo.webp';

const stats = [
  { icon: Building2, value: '1000+', label: 'Global Brands' },
  { icon: Globe, value: '100+', label: 'Countries' },
  { icon: Award, value: '15+', label: 'Industries' },
  { icon: Users, value: '98%', label: 'Client Retention' },
];

export const ClientsPage = () => {
  return (
    <main data-testid="clients-page" className="pt-24 min-h-screen bg-[#0a0a0a]">
      <SEO 
        title="Our Clients - 1000+ Global Brands Trust Us"
        description="Golden Tree Events partners with 1000+ global brands across 100+ countries. World-renowned hotels, resorts, entertainment destinations, and corporate leaders trust our event management."
        keywords="Golden Tree Events clients, event management partners, hospitality clients, corporate event clients, global brands"
      />
      {/* Hero Section */}
      <section className="py-16 md:py-24 border-b border-white/10">
        <div className="w-full px-4 sm:px-8 lg:px-16">
          <div className="text-center">
            <p className="font-google-sans text-[#D4AF37] text-xs tracking-[0.3em] uppercase mb-4">Our Clients</p>
            <h1 className="font-montserrat text-4xl sm:text-5xl lg:text-6xl text-white mb-6">
              Trusted by <span className="gradient-gold">1000+</span> Brands
            </h1>
            <p className="font-google-sans text-[#A1A1AA] text-lg max-w-2xl mx-auto">
              From world-renowned hotels to innovative entertainment destinations, we've partnered with 
              leading organizations across every industry.
            </p>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-12 border-b border-white/10 bg-[#121212]">
        <div className="w-full px-4 sm:px-8 lg:px-16">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center group">
                <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-[#D4AF37]/10 mb-4 group-hover:bg-[#D4AF37]/20 transition-colors duration-300">
                  <stat.icon className="w-6 h-6 text-[#D4AF37]" />
                </div>
                <span className="font-montserrat text-4xl text-[#D4AF37] block">{stat.value}</span>
                <p className="text-[#A1A1AA] text-sm mt-2">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Clients Logo Grid */}
      <section className="py-16">
        <div className="w-full px-4 sm:px-8 lg:px-16">
          <h2 className="font-montserrat text-2xl sm:text-3xl text-white mb-8 text-center">
            Featured <span className="gradient-gold">Partners</span>
          </h2>
          
          {/* Logo Image Container */}
          <div className="relative group">
            {/* Decorative border */}
            <div className="absolute -inset-1 bg-gradient-to-r from-[#D4AF37]/20 via-[#D4AF37]/5 to-[#D4AF37]/20 rounded-2xl blur-sm opacity-50 group-hover:opacity-75 transition-opacity duration-500"></div>
            
            {/* Main container */}
            <div className="relative bg-white rounded-2xl p-4 sm:p-6 lg:p-8 shadow-2xl">
              <img
                src={CLIENT_LOGOS_IMAGE}
                alt="Our Global Client Partners - Hotels, Resorts, Entertainment Destinations"
                className="w-full h-auto rounded-lg"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-[#121212] to-[#1a1a1a]">
        <div className="w-full px-4 sm:px-8 lg:px-16 text-center">
          <h2 className="font-montserrat text-3xl sm:text-4xl text-white mb-4">
            Join Our Growing Client List
          </h2>
          <p className="font-google-sans text-[#A1A1AA] mb-8 max-w-xl mx-auto">
            Partner with the world's leading award management company and elevate your brand recognition.
          </p>
          <Link
            to="/contact-us"
            data-testid="clients-contact-cta"
            className="inline-flex items-center gap-2 bg-[#D4AF37] text-black font-medium px-8 py-4 uppercase tracking-widest text-sm hover:bg-[#C5A028] transition-all duration-300"
          >
            Become a Client
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </main>
  );
};

export default ClientsPage;
